import BuildingType from '@/roc/building/BuildingType';
import Effects from '@/roc/effects/Effects';
import ProductionCurrency from '@/roc/effects/Production/ProductionCurrency';
import ProductionOutputType from '@/roc/effects/Production/ProductionOutputType';
import ProductionQueue from '@/roc/effects/Production/ProductionQueue';
import ProductionWorkforce from '@/roc/effects/Production/ProductionWorkforce';
import ProductionCost from '@/roc/effects/Production/ProductionCost';
import ProductionDuration from '@/roc/effects/Production/ProductionDuration';
import ProductionOutput from '@/roc/effects/Production/ProductionOutput';

const MongolianSaddler = {
  id: '83',
  name: 'Mongolian Saddler',
  width: 3,
  height: 2,
  type: BuildingType.COLLECTABLE,
  era: 'stoneAge',
  icon: 'Mongolian_Saddler',
  minLevel: 1,
  maxLevel: 40,
  url: 'https://riseofcultures.wiki.gg/wiki/Buildings/Mongolian_Saddler',
  flags: 0,
  counts: null,
  effects: Effects.create([
    new ProductionQueue(
      ProductionWorkforce.asFlat(3),
      [
        ProductionCost.asPerLevel([
          2000, 1833, 1692, 1571, 1466, 1375, 1294, 1222, 1157, 1100,
          1047, 1000, 956, 916, 880, 846, 814, 785, 756, 733,
          709, 687, 666, 647, 628, 611, 594, 578, 564, 550,
          536, 523, 511, 500, 488, 478, 468, 458, 448, 440,
        ]).withCurrency(ProductionCurrency.PREVIOUS_ERA_PRIMARY_GOODS),
      ],
      ProductionDuration.asFlat(8 * 60 * 60),
      ProductionOutput.asFlat(1).withOutput(ProductionOutputType.RANDOM_BARRACKS_REFILL),
    ),
    new ProductionQueue(
      ProductionWorkforce.asFlat(3),
      [
        ProductionCost.asPerLevel([
          3000, 2800, 2625, 2470, 2333, 2210, 2100, 2000, 1909, 1826,
          1750, 1680, 1615, 1555, 1500, 1448, 1400, 1354, 1312, 1272,
          1235, 1200, 1166, 1135, 1105, 1076, 1050, 1024, 1000, 976,
          954, 933, 913, 893, 875, 857, 840, 823, 807, 792
        ]).withCurrency(ProductionCurrency.PREVIOUS_ERA_PRIMARY_GOODS),
      ],
      ProductionDuration.asFlat(12 * 60 * 60),
      ProductionOutput.asFlat(1).withOutput(ProductionOutputType.BARRACKS_REFILL_SELECTION_KIT),
    ),
  ])
};

export default MongolianSaddler;
